import { useEffect, useState } from "react";
import { useApi } from "utils"

export type SuccessFetch = {
    status: string;
    responseStatus: number;
    message: string;
    payload: {
        project_file_code:string
    };
};

export function useProjectFileCode() {
    const api = useApi()
    const [code, setCode] = useState("")

    const fetchData = async () => {
        try {
            const res = await api.get(`/project/generate-project-file-code`);
            const response: SuccessFetch = res.data;

            setCode(response.payload.project_file_code);
            return response.payload.project_file_code; // BALIKKAN KODE BARU
        } catch (err) {
            setCode("");
            return "";
        }
    };

    const refetchCode = async () => {
        return await fetchData();  // WAJIB RETURN dari fetchData
    };

    useEffect(() => {
        fetchData();
         // eslint-disable-next-line
    }, []);

    return {
        code,
        refetchCode
    };
}